export const specialTextGradientStyle = {
  WebkitTextStroke: "2px #670026",
  textStroke: "2px #670026",
  background: "linear-gradient(#FAD502,#FEFB30,#FAD502)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontFamily: "'Berlin Sans FB Demi', sans-serif",
  display: "inline-block",
};
